import { Component } from '@angular/core';

@Component({
  selector: 'phc-trading-sell-image-component',
  templateUrl: './trading-sell.component.html',
  styleUrls: ['./trading-sell.component.scss']
})
export class TradingSellComponent  {


}
